import Wrapper from "../../layout/Wrapper";
import LoginComponent from "../../screens/login";

import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
  title: "Login",
  description: "",
};

export default function Login() {
  return (
    <Wrapper>
    	<MetaComponent meta={metadata} />
      	<LoginComponent />
    </Wrapper>
  );
}